import {useWebsiteMenuInformation} from '@data/queries/website/websiteMenuInformation.main'

function useCartV3() {
  const {website} = useWebsiteMenuInformation()
  return website.businessType === 'restaurant'
}

export default useCartV3
